import { format } from "date-fns";
import { it } from "date-fns/locale";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import CustomFactoryIcon from "../../../app/assets/custom-icons/CustomFactoryIcon";
import CustomManageUsersIcon from "../../../app/assets/custom-icons/CustomManageUsersIcon";
import CustomOperatorIcon from "../../../app/assets/custom-icons/CustomOperatorIcon";
import CustomStudioManagementIcon from "../../../app/assets/custom-icons/CustomStudioManagementIcon";
import CoreChip from "../../../app/core/components/CoreChip/CoreChip.jsx";
//import CoreTabBar from "../../../app/core/components/CoreTabBar/CoreTabBar.jsx";
import { ROLE, SUB_ROLE } from "../../../utils/constants/profiles.js";
import { TABLE_ROWS_NUMBER } from "../../../utils/constants/tables.js";
import { labelForDashboard } from "../../../utils/functions/filters.js";
import { hexToRgba } from "../../../utils/functions/hexToRgba";
import {
  useGetCardStatsQuery,
  useGetCategoryStatsQuery,
  useGetMonthWeekStatsQuery,
  useLazyGetDownloadStatsQuery,
} from "../../api/admin/dashboardApi.js";
import { useGetCommercialistaQuery } from "../../api/admin/gestisciCommercialistiApi.js";
import { useGetStudiosQuery } from "../../api/admin/gestisciStudioApi.js";
import { useGetUsersQuery } from "../../api/admin/gestisciUtentiApi.js";
import {
  useGetUserCategoryStatsQuery,
  useGetUserMonthWeekStatsQuery,
  useGetUserStatsQuery,
} from "../../api/user/userDashboardApi.js";
import CardContainer from "./DocumentView/Card/CardContainer.jsx";
import CardCounter from "./DocumentView/Card/CardCounter.jsx";
import CardBarChart from "./DocumentView/Chart/CardBarChart.jsx";
import CardLineChart from "./DocumentView/Chart/CardLineChart.jsx";
import CardPieChart from "./DocumentView/Chart/CardPieChart.jsx";
import FilterDocument from "./DocumentView/FilterDocument.jsx";

const DashboardPage = () => {
  const appConfig = useSelector((state) => state.app.appConfig);
  const role = useSelector((state) => state.app.role);
  const subRole = useSelector((state) => state.app.subRole);

  const CardCount =
    ROLE.ADMIN === role ? 3 : SUB_ROLE.OPERATOR === subRole ? 1 : 2;

  const [selectedTab, setSelectedTab] = useState("documenti");

  const [counter, setCounter] = useState({});
  const [card, setCard] = useState(
    Array(
      appConfig?.modules?.company?.general ? CardCount + 1 : CardCount
    ).fill({})
  );
  const [month, setMonth] = useState([]);
  const [week, setWeek] = useState([]);
  const [category, setCategory] = useState([]);

  const [filter, setFilter] = useState({
    adminId: "",
    studioId: "",
    userId: "",
  });

  const [debouncedInputStudioValue, setDebouncedInputStudioValue] =
    useState("");
  const [debouncedInputOperatorValue, setDebouncedInputOperatorValue] =
    useState("");
  const [debouncedInputUserValue, setDebouncedInputUserValue] = useState("");

  const page = {
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  };

  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const colorSecondary = useSelector((state) => state.app.secondaryColor);

  const rgbaColor = hexToRgba(colorPrimary, 0.3);

  const TABS_DASHBOARD = [
    { label: "Documenti", tab: "documenti" },
    { label: "Attività", tab: "attività" },
    { label: "Magic View", tab: "magic-view", admin: ROLE.USER === role },
  ];

  // API ADMIN
  const { data: dataCard, isLoading: isLoadingCard } = useGetCardStatsQuery(
    filter,
    { refetchOnMountOrArgChange: true, skip: ROLE.USER === role }
  );
  const { data: dataChart, isLoading: isLoadingChart } =
    useGetMonthWeekStatsQuery(filter, {
      refetchOnMountOrArgChange: true,
      skip: ROLE.USER === role,
    });

  const { data: dataCategory, isLoading: isLoadingCategory } =
    useGetCategoryStatsQuery(filter, {
      refetchOnMountOrArgChange: true,
      skip: ROLE.USER === role,
    });

  const { data: dataStudio, isLoading: isLoadingStudio } = useGetStudiosQuery(
    {
      ...page,
      value: debouncedInputStudioValue,
      studioId: filter.studioId,
    },
    { skip: ROLE.USER === role }
  );

  const { data: dataOperators, isLoading: isLoadingOperators } =
    useGetCommercialistaQuery(
      {
        page: { startRow: 0, endRow: 20 },
        value: debouncedInputOperatorValue,
        adminId: filter.adminId,
      },
      { skip: ROLE.USER === role }
    );

  const { data: dataUsers, isLoading: isDataUsersLoading } = useGetUsersQuery(
    {
      page: { startRow: 0, endRow: 20 },
      value: debouncedInputUserValue,
      userId: filter.userId,
    },
    { skip: ROLE.USER === role }
  );

  const [downloadExcel] = useLazyGetDownloadStatsQuery();

  // API USER
  const { data: dataUserCard, isLoading: isLoadingUserCard } =
    useGetUserStatsQuery(
      { refetchOnMountOrArgChange: true },
      { skip: ROLE.USER !== role }
    );
  const { data: dataUserChart, isLoading: isLoadingUserChart } =
    useGetUserMonthWeekStatsQuery(
      { refetchOnMountOrArgChange: true },
      { skip: ROLE.USER !== role }
    );

  const { data: dataUserCategory, isLoading: isLoadingUserCategory } =
    useGetUserCategoryStatsQuery(
      { refetchOnMountOrArgChange: true },
      { skip: ROLE.USER !== role }
    );

  useEffect(() => {
    const processCountSummary = (data) => {
      setCounter({
        Tot: data.Data.totalDocuments,
        Validated: data.Data.validatedDocuments,
        NotValidated: data.Data.pendingDocuments,
        Reject: data.Data.rejectedDocuments,
      });
    };
    if (dataCard && dataCard.Data) {
      setCard(
        [
          {
            id: 1,
            label: t("Users"),
            value: dataCard.Data.totalUsers,
            add: dataCard.Data.recentUsers,
            icon: <CustomManageUsersIcon className="w-20 h-20" />,
            show: true,
          },
          {
            id: 2,
            label: t("Operators"),
            value: dataCard.Data.totalOperators,
            add: dataCard.Data.recentOperators,
            icon: <CustomOperatorIcon className="w-20 h-20" />,
            show: SUB_ROLE.OPERATOR !== subRole,
          },
          {
            id: 3,
            label: t("Studios"),
            value: dataCard.Data.totalStudios,
            add: dataCard.Data.recentStudios,
            icon: <CustomStudioManagementIcon className="w-20 h-20" />,
            show: ROLE.ADMIN === role,
          },
          {
            id: 4,
            label: t("Companies"),
            value: dataCard.Data.totalCompanies,
            add: dataCard.Data.recentCompanies,
            icon: <CustomFactoryIcon className="w-20 h-20" />,
            show: appConfig.modules.company.general,
          },
        ].filter((el) => el.show)
      );

      processCountSummary(dataCard);
    }

    if (dataUserCard && dataUserCard.Data) processCountSummary(dataUserCard);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCard, dataUserCard]);

  useEffect(() => {
    const processMonthlySummary = (data) => {
      const datiMensili = data.Data.monthlySummary.map((el) => ({
        month: el.month,
        uploaded: el.uploaded,
        validated: el.validated,
        rejected: el.rejected,
        pending: el.validating,
        year: el.year,
      }));
      setMonth(datiMensili);
    };

    const processWeeklySummary = (data) => {
      const datiSettimanali = data.Data.weeklySummary
        .map((el) => ({
          week: el.week,
          year: el.year,
          dailyDetails: el?.dailyDetails.map((el) => ({
            day:
              format(new Date(el.date), "EEEE", {
                locale: it,
              })
                .charAt(0)
                .toUpperCase() +
              format(new Date(el.date), "EEEE", {
                locale: it,
              }).slice(1),
            uploaded: el.uploaded,
            validated: el.validated,
            rejected: el.rejected,
            pending: el.validating,
          })),
        }))
        .pop(); // prendo sempre ultima week

      setWeek(datiSettimanali);
    };

    if (dataChart && dataChart.Data) {
      processMonthlySummary(dataChart);
      processWeeklySummary(dataChart);
    }
    if (dataUserChart && dataUserChart.Data) {
      processMonthlySummary(dataUserChart);
      processWeeklySummary(dataUserChart);
    }
  }, [dataChart, dataUserChart]);

  useEffect(() => {
    const processCategorySummary = (data) => {
      setCategory([
        {
          id: 0,
          value: data?.Data[2]?.documentCount,
          label: "Redditi",
          color: colorPrimary,
        },
        {
          id: 1,
          value: data?.Data[1]?.documentCount,
          label: "Detrazioni e Deduzioni",
          color: colorSecondary,
        },
        {
          id: 2,
          value: data?.Data[0]?.documentCount,
          label: "Altri Documenti",
          color: rgbaColor,
        },
      ]);
    };

    if (dataCategory && dataCategory.Data) processCategorySummary(dataCategory);

    if (dataUserCategory && dataUserCategory.Data)
      processCategorySummary(dataUserCategory);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCategory, dataUserCategory]);

  const handleRemoveFilter = (f) => {
    let newFilter = { ...filter };
    Object.entries(newFilter).forEach(([k, v]) => {
      if (v === f) {
        newFilter[k] = "";
      }
    });
    setFilter(newFilter);
  };

  const excelRequest = (query) =>
    new Promise((resolve, reject) => {
      downloadExcel(query)
        .then((res) => {
          if (!res.isSuccess) throw new Error("Niente da fare");
          resolve(window.location.assign(window.URL.createObjectURL(res.data)));
        })
        .catch(() => reject());
    });

  const handleDownloadExcel = (query) => {
    toast.promise(
      excelRequest(query),
      {
        pending: {
          render: t("HandleDownload"),
          type: "info",
        },
        success: t("FileReady"),
        error: t("ReqErr"),
      },
      { autoClose: 1500 }
    );
  };

  return (
    <div className="flex flex-col">
      <div className="flex justify-between items-center space-x-4">
        <h2>Dashboard</h2>
        {/*         <CoreTabBar tab={TABS_DASHBOARD} setSelectedTab={setSelectedTab} /> */}
        {ROLE.USER !== role && (
          <>
            <div className="flex justify-end gap-4">
              {Object.entries(filter).map(
                ([k, v]) =>
                  v && (
                    <CoreChip
                      key={v}
                      label={labelForDashboard(
                        k,
                        v,
                        dataStudio,
                        dataOperators,
                        dataUsers
                      )}
                      variant="outlined"
                      onDelete={() => handleRemoveFilter(v)}
                    />
                  )
              )}
              {SUB_ROLE.OPERATOR !== subRole && (
                <FilterDocument
                  dataStudio={dataStudio}
                  dataOperators={dataOperators}
                  dataUsers={dataUsers}
                  setFilter={setFilter}
                  filter={filter}
                  setDebouncedInputStudioValue={setDebouncedInputStudioValue}
                  setDebouncedInputOperatorValue={
                    setDebouncedInputOperatorValue
                  }
                  setDebouncedInputUserValue={setDebouncedInputUserValue}
                />
              )}
            </div>
          </>
        )}
      </div>

      {selectedTab === "documenti" && (
        <div className="py-8">
          {ROLE.USER !== role ? (
            <>
              <CardContainer
                card={card}
                counter={counter}
                isLoading={isLoadingCard}
              />
              <div className="py-8 m-4">
                <CardLineChart
                  dataMonth={month}
                  downloadExcel={handleDownloadExcel}
                />
              </div>
              <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 m-4 py-8">
                <CardBarChart
                  dataWeek={week?.dailyDetails}
                  downloadExcel={handleDownloadExcel}
                />
                <CardPieChart
                  dataCategory={category}
                  downloadExcel={handleDownloadExcel}
                />
              </div>
            </>
          ) : (
            <>
              <CardCounter counter={counter} isLoading={isLoadingUserCard} />
              <div className="py-8 m-4">
                <CardLineChart dataMonth={month} />
              </div>
              <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 m-4 py-8">
                <CardBarChart dataWeek={week?.dailyDetails} />
                <CardPieChart dataCategory={category} />
              </div>
            </>
          )}
        </div>
      )}
      {selectedTab === "attività" && (
        <div className="flex w-full h-screen  justify-center items-center">
          <p className="text-3xl text-gray ">Dashboard Attività in arrivo</p>
        </div>
      )}
      {selectedTab === "magic-view" && (
        <div className="flex w-full h-screen  justify-center items-center">
          <p className="text-3xl text-gray ">Magic View in arrivo</p>
        </div>
      )}
    </div>
  );
};

export default DashboardPage;
